import { toast } from "sonner";
import { api } from "@/lib/api";

const ASKED = "cs_push_asked";
const IOS_HINT = "cs_push_ios_hint";

export const pushSupported = () => "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
const isIOS = () => /iphone|ipad|ipod/i.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);
const standalone = () => window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const registerPushWorker = () => {
  if ("serviceWorker" in navigator) navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => {});
};

const toBytes = (b64) => {
  const raw = atob((b64 + "=".repeat((4 - (b64.length % 4)) % 4)).replace(/-/g, "+").replace(/_/g, "/"));
  return Uint8Array.from(raw, (c) => c.charCodeAt(0));
};

export async function subscribePush() {
  const reg = await navigator.serviceWorker.ready;
  let sub = await reg.pushManager.getSubscription();
  if (!sub) {
    const { data } = await api.get("/push/key");
    sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: toBytes(data.key) });
  }
  await api.post("/push/subscriptions", sub.toJSON());
}

export async function enablePush() {
  const perm = await Notification.requestPermission();
  if (perm !== "granted") {
    toast.info("Notifiche non attivate: puoi abilitarle in seguito dalle impostazioni del telefono");
    return false;
  }
  try {
    await subscribePush();
    toast.success("Notifiche attive: ti avvisiamo quando un desiderio torna disponibile");
    return true;
  } catch {
    toast.error("Non è stato possibile attivare le notifiche su questo dispositivo");
    return false;
  }
}

export function offerPush() {
  if (!pushSupported()) {
    if (isIOS() && !standalone() && !localStorage.getItem(IOS_HINT)) {
      localStorage.setItem(IOS_HINT, "1");
      toast.info("Vuoi una notifica quando torna disponibile?", {
        description: "Su iPhone aggiungi Card Source alla schermata Home (Condividi → Aggiungi alla schermata Home) e aprilo da lì.", duration: 10000,
      });
    }
    return;
  }
  if (Notification.permission === "granted") { subscribePush().catch(() => {}); return; }
  if (Notification.permission === "denied" || localStorage.getItem(ASKED)) return;
  localStorage.setItem(ASKED, String(Date.now()));
  toast("Vuoi una notifica sul telefono?", {
    description: "Ti avvisiamo quando un prodotto dei desideri torna disponibile o apre il preordine.",
    duration: 12000,
    action: { label: "Attiva", onClick: () => { enablePush(); } },
  });
}

export function refreshPush() {
  if (pushSupported() && Notification.permission === "granted") subscribePush().catch(() => {});
}
